module.exports = __webpack_public_path__ + "static/media/step1.e078a37a.png";